import {
  APP_INITIALIZED, FETCH_BEGIN, FETCH_END, TOGGLE_NOTIFICATION, QUOTES_FETCH_REQUESTED, QUOTES_FETCHED, QUOTES_FETCH_FAILED
} from 'utils/constants'
const initialState = {
  notificationMsg: null,
  showSpinner: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case APP_INITIALIZED:
      const { api } = action.data;
      return { api };
    case FETCH_BEGIN:
      return { ...state, showSpinner: true };
    case FETCH_END:
      return { ...state, showSpinner: false, notificationMsg: action.data && action.data.notificationMsg };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/app.js